import { createRouter, createWebHistory } from "vue-router";

const routes = [
  // 重定向（设定默认路由）
  {
    path: "/",
    redirect: "/homePage",
  },
  {
    path: "/homePage",
    meta: { title: "极动科技" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/homePage/homePage.vue"),
  },
  {
    path: "/test",
    meta: { title: "测试" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/tempFile"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
